import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from '../services/auth';
import { userApi } from '../services/api';

export default function DeleteAccountSection() {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmText, setConfirmText] = useState('');
  const [deleting, setDeleting] = useState(false);
  const [error, setError] = useState('');

  async function handleDelete() {
    if (confirmText !== 'DELETE') return;
    setError('');
    setDeleting(true);
    try {
      await userApi.deleteAccount();
      try { await signOut(); } catch {}
      navigate('/login', { replace: true });
    } catch (err) {
      setError(err?.message || 'Failed to delete account');
      setDeleting(false);
    }
  }

  return (
    <div className="bg-white dark:bg-night-surface rounded-2xl overflow-hidden border border-gray-100 dark:border-night-card">
      <div className="px-4 py-3 border-b border-gray-100 dark:border-night-card">
        <p className="text-xs font-semibold text-red-600 dark:text-red-400 uppercase tracking-wider">
          Danger Zone
        </p>
      </div>

      <div className="px-4 py-3">
        {!showConfirm ? (
          <button
            onClick={() => setShowConfirm(true)}
            className="w-full flex items-center gap-3 px-3 py-2 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors text-left"
            aria-label="Delete account"
          >
            <span className="text-red-500 text-lg" aria-hidden="true">🗑</span>
            <span className="text-sm font-medium text-red-600 dark:text-red-400">Delete Account</span>
          </button>
        ) : (
          <div className="space-y-3">
            <div className="p-3 bg-red-50 dark:bg-red-900/20 rounded-lg border border-red-200 dark:border-red-800">
              <p className="text-sm font-medium text-red-700 dark:text-red-400">
                This action is permanent and cannot be undone.
              </p>
              <p className="text-xs text-red-600 dark:text-red-400 mt-1">
                All your habits, check-ins, and history will be permanently deleted.
                Active subscriptions must be cancelled separately through your App Store
                or payment provider.
              </p>
            </div>

            <div>
              <label htmlFor="delete-confirm" className="block text-xs text-gray-500 dark:text-night-muted mb-1">
                Type <strong>DELETE</strong> to confirm
              </label>
              <input
                id="delete-confirm"
                type="text"
                value={confirmText}
                onChange={(e) => setConfirmText(e.target.value)}
                className="input-field"
                placeholder="DELETE"
                autoComplete="off"
                autoCapitalize="characters"
              />
            </div>

            {error && <p className="text-xs text-red-500">{error}</p>}

            <div className="flex gap-2">
              <button
                onClick={handleDelete}
                disabled={confirmText !== 'DELETE' || deleting}
                className="btn-danger flex-1"
              >
                {deleting ? 'Deleting…' : 'Permanently Delete Account'}
              </button>
              <button
                onClick={() => { setShowConfirm(false); setConfirmText(''); setError(''); }}
                disabled={deleting}
                className="btn-secondary"
              >
                Cancel
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
